import React from "react";
import { useLocation } from "react-router-dom";
import Copyright from "./copyright";
import { mnlRoutes } from "routes/mnlRoutes";

const Footer = () => {
  const location = useLocation();
  const isRouteInvalid = !mnlRoutes.some((route) =>
    route.path.includes(location.pathname)
  );
  const isInAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/confirm-account" ||
    location.pathname === "/lab" ||
    location.pathname === "/lab-change-user-password" ||
    location.pathname === "/unauthorized" ||
    location.pathname === "/reset-password";
  return (
    <footer
      className={`h-11 fixed bottom-0 bg-[#1976D2] w-[100%] flex justify-center items-center z-10 ${
        (isInAuthPage || isRouteInvalid) && "hidden"
      }`}
    >
      <Copyright color="white" />
    </footer>
  );
};

export default Footer;
